import { BareActionContext } from 'vuex-typex'
import { AuthState } from '../state'
import { RootState } from '@/store/'
import { IUser } from '../../../model/user'
import authStore from '../auth-store'
import authUtils from './auth-utils'

export default async function facebookAuth(context: BareActionContext<AuthState, RootState>, access_token: string) {
  if (!authStore.isAuthenticated) {
    authUtils.authService.facebookAuth(access_token).then((user: IUser | null) => {
      if (!user) {
        authStore.commitPurgeUser()
      } else {
        authStore.commitSetUser({ user: user })
      }
    })
  }
}
